import { bootstrapApplication } from '@angular/platform-browser';
import { answerRedirectBridge } from '@groundworks/ngx-groundworks-auth';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Silent token renewal loads the app in a hidden iframe that must hand MSAL its response and
// stop (G-12). Answer it before anything else runs; bootstrap everywhere else.
if (!answerRedirectBridge()) {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
}
